<div class="flex flex-col">
  <div class="flex flex-col-reverse w-full relative">
    <div
      [class]="inputClasses"
      [attr.data-focus]="isOpen"
      [attr.data-read-only]="readOnly"
      (click)="onFocus()"
    >
      <div class="flex flex-wrap gap-2">
        @for (item of selectedItems; track $index) {
          <span
            (click)="$event.stopPropagation(); removeItem($index)"
            [class]="
              'whitespace-nowrap px-3 py-0.5 text-sm font-medium rounded-md border flex items-center ' +
              chipClasses
            "
            >{{ item.label }}<span class="icon-close cursor-pointer ml-2"></span
          ></span>
        }
        <input
          class="pr-8 max-w-52 w-full bg-transparent border-0 focus:ring-0 focus:outline-none"
          [id]="id"
          [readOnly]="false"
          [disabled]="disabled"
          [placeholder]="placeholder"
          [required]="invalid || (required && touched)"
          [attr.pattern]="invalid ? 'SAG_INVALID_STATE' : null"
          [attr.aria-label]="ariaLabel"
          [attr.aria-labelledby]="ariaLabelledby || id"
          [attr.aria-describedby]="ariaDescribedby"
          (input)="handleInput($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
          (keydown)="keydownHandler($event)"
          (keyup)="keyup.emit($event)"
          (mouseenter)="mouseenter.emit($event)"
          (mouseleave)="mouseleave.emit($event)"
          type="text"
          #input
        />
      </div>
    </div>
    <label [htmlFor]="id" sag-ui-input-label>
      @if (required) {
        <span>*</span>
      }
      {{ label }}
      @if (hint) {
        <span
          class="text-[#999999] dark:text-[#666666] icon-circle-information pl-2"
          [tooltip]="hint"
          sag-ui-tooltip
        ></span>
      }
    </label>
    @if (loading) {
      <sag-ui-spinner
        class="absolute right-4 top-[37px]"
        size="sm"
      ></sag-ui-spinner>
    } @else {
      <span
        class="absolute right-4 bottom-[0.8rem] z-20 text-black dark:text-white"
        [class.icon-chevron-up]="isOpen"
        [class.icon-chevron-down]="!isOpen"
        [class.opacity-50]="disabled"
        (click)="!disabled && togglePopover($event)"
      ></span>
    }
    <div
      [class]="popoverClasses"
      [class.hidden]="!isOpen"
      (scroll)="onScroll($event)"
      style="max-height: 200px; overflow-y: auto"
    >
      @if (options.length === 0) {
        <sag-ui-multi-autocomplete-option
          class="autocomplete-option"
          (click)="handleAddOption()"
        >
          <div class="flex items-center justify-between gap-2">
            <span>{{ inputValue }}</span>
            <span
              class="rounded-md text-xs text-white bg-[#005159] px-3 py-0.5 flex items-center gap-2"
              ><span class="icon-plus-large"></span>Hinzufügen</span
            >
          </div>
        </sag-ui-multi-autocomplete-option>
      } @else {
        @for (option of options; track option.value) {
          <sag-ui-multi-autocomplete-option
            class="autocomplete-option"
            (click)="handleOptionSelect([option.label, option.value])"
          >
            {{ option.label }}
          </sag-ui-multi-autocomplete-option>
        }
      }
    </div>
  </div>
  @if (error && isArray(error)) {
    <div class="flex flex-col gap-1">
      @for (err of error; track err) {
        <span sag-ui-input-error>{{ err }}</span>
      }
    </div>
  } @else {
    <span sag-ui-input-error>{{ error }}</span>
  }
</div>
